import { render, staticRenderFns } from "./ContactIconLink.vue?vue&type=template&id=4951da7c&scoped=true&"
import script from "./ContactIconLink.vue?vue&type=script&lang=js&"
export * from "./ContactIconLink.vue?vue&type=script&lang=js&"
import style0 from "./ContactIconLink.vue?vue&type=style&index=0&id=4951da7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4951da7c",
  null
  
)

export default component.exports